<template>
  <div class="container-fluid main-container m-0 p-0 full"
    :style="{ 'backgroundImage': `url(${getDestination.backgrounds[0].url})` }">
    <div class="container-fluid bg h-100 position-relative">
      <img src="../../assets/images/landing/details-section/detail4.png" class="detail4 position-absolute" v-if="branding.logoImgUrl"/>
      <div class="row h-100 position-relative">
        <img src="../../assets/images/landing/details-section/detail2.png" class="detail3 position-absolute" v-if="branding.logoImgUrl"/>
        <div class="col-12">
          <div class="row">
            <div class="col text-center p-3 position-relative">
              <img src="../../assets/images/landing/details-section/detail1.png" alt=""
                class="detail1 position-absolute" v-if="branding.logoImgUrl">
              <img src="../../assets/images/landing/details-section/detail2.png" alt=""
                class="detail2 position-absolute" v-if="branding.logoImgUrl">
              <img src="../../assets/images/landing/logo.png" alt="">
            </div>
          </div>
        </div>
        <div
          class="col-12 d-flex justify-content-center align-items-lg-center align-items-end pt-3 pt-sm-5 mt-3 mt-sm-5 pt-lg-0 mt-lg-0 px-0">
          <div class="container px-3 pt-1 pt-sm-5 mt-1 mt-sm-5 pt-lg-0 mt-lg-0">
            <div class="row d-flex align-content-center h-100">
              <div
                class="col-12 col-lg-6 contBlack justify-content-center align-items-center align-self-center position-relative">
                <img src="../../assets/images/landing/details-section/black-friday.png"
                  class="blackfriday position-absolute d-lg-none" v-if="branding.logoImgUrl" />
                <img src="../../assets/images/landing/details-section/black-friday2.png"
                  class="blackfriday position-relative d-none d-lg-flex" v-if="branding.logoImgUrl" />
                <div class="col col-lg-10">
                  <h1 class="lbl-01__title"> {{ getDestination.name }}
                    <br>
                    <span class="d-lg-none">All-Inclusive <br /> Resort Package</span>
                    <span class="d-none d-lg-flex">Luxury Vacation </span>
                  </h1>
                  <h3 class="my-lg-3"> <span class="lbl-01__sub px-2 py-1 py-lg-2" :style="branding.priceBlock">${{ getCopy.priceUSD }} {{ getCopy.home.hero.priceSuffix }}</span></h3>
                  <p class="lbl-01__p fw-semibold d-lg-none">
                  {{ getCopy.home.hero.descriptionMobile }}
                  </p>
                  <p class="lbl-01__p fw-semibold d-none d-lg-flex w-100" v-html="getCopy.home.hero.descriptionDesktop">
                    
                  </p>
                </div>
              </div>
              <div class="col-12 col-lg-6 d-flex justify-content-center pt-3">
                <div class="col col-lg-7 mb-2 pb-1 rounded">
                  <TheForm :destination="getDestination.name" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 d-flex justify-content-center align-items-end">
          <div class="row">
            <div class="col text-center"><img src="../../assets/images/landing/details-section/arrow-down.gif" alt=""
                class="rounded-top-5 p-1 arrow-icon"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <the-details :gallery="getDestination.gallery" :details="getDestination.packageDetails" />

  <div class="container-fluid amenities-bg  p-0 position-relative overflow-hidden"
    :style="{ 'backgroundImage': `url(${this.getDestination.backgrounds[1].url})` }">
    <img class="detail5 position-absolute" src="../../assets/images/landing/details-section/detailCircles.png" v-if="branding.logoImgUrl"/>
    <img class="detail6 position-absolute" src="../../assets/images/landing/details-section/detailCircles.png" v-if="branding.logoImgUrl"/>
    <div class="container-fluid p-0 bg-shadow">
      <div class="row justify-content-around px-2 py-4 align-items-center">
        <div class="col-12 colSim pb-5 pb-lg-0 lh-sm">
          <h3 class="z2 text-white">{{ getDestination.name }}</h3>
          <span class="h64">{{ getCopy.amenities.subheading }}</span>
          <br />
          <h3 class="price-txt" :style="branding.priceDetailsBlock">${{ getCopy.priceUSD }} USD {{ getCopy.amenities.priceLine }}</h3>
          <h4 class="text-white fw-semibold">Regular Price: <span class="text-decoration-line-through">${{ getCopy.retailPriceUSD }}</span>
          </h4>
        </div>
        <div class="col-12 col-lg-4 tagContainer pt-lg-0 position-relative">
          <p class="fs-5 text-white pt-5">
            {{ getDestination.destinationDescription.paragraph }}
          </p>
          <img class="detail7 position-absolute" src="../../assets/images/landing/details-section/detailTag1.png" v-if="branding.logoImgUrl"/>
        </div>
      </div>
    </div>
  </div>
  <div class="container-fluid highlights-list bg-clouds">
    <div class="container p-lg-5">
      <div class="row gy-4">
        <h3 class="fw-bold pt-5 newRed" :style="branding.titles">Highlights</h3>
        <div class="col-12 col-lg-4 mt-0">
          <ul class="list-group list-group-flush">
            <li class="list-group-item">
              <img src="../../assets/icons/amenities/pool.png" alt="">
              <span></span>Multiple Pools & Beach Access
            </li>
            <li class="list-group-item">
              <img src="../../assets/icons/amenities/lunch_dining.png" alt="">
              <span></span>Indulge In Diverse Dining Options
            </li>
            <li class="list-group-item">
              <img src="../../assets/icons/amenities/wine_bar.png" alt="">
              <span></span>Wine Bar & Pool Bar
            </li>
            <li class="list-group-item">
              <img src="../../assets/icons/amenities/local_activity.png" alt="">
              <span></span>Nightly Entertainment
            </li>
            <li class="list-group-item">
              <img src="../../assets/icons/amenities/spa.svg" alt="">
              <span></span>Enjoy Massage and Spa Luxuries
            </li>
            <li class="list-group-item p-0"></li>
          </ul>
        </div>
        <div class="col-12 col-lg-4 mt-0">
          <ul class="list-group list-group-flush">
            <li class="list-group-item">
              <img src="../../assets/icons/amenities/beach_access.png" alt="">
              <span></span>Pool & Beach Wait Service
            </li>
            <li class="list-group-item">
              <img src="../../assets/icons/amenities/cleaning_services.png" alt="">
              <span></span>Daily Maid & turn down service
            </li>
            <li class="list-group-item">
              <img src="../../assets/icons/amenities/liquor.png" alt="">
              <span></span>Oceanfront Bars & Venues
            </li>
            <li class="list-group-item d-none d-lg-flex">
              <img src="../../assets/icons/amenities/airport_shuttle.png" alt="">
              <span></span>Free Shuttle to and from the Airport
            </li>
            <li class="list-group-item d-none d-lg-flex">
              <img src="../../assets/icons/amenities/room_service.png" alt="">
              <span></span>Room service
            </li>
            <li class="list-group-item p-0"></li>
          </ul>
        </div>
        <div class="col-12 col-lg-4 mt-0">
          <ul class="list-group list-group-flush">
            <li class="list-group-item d-none d-lg-flex">
              <img src="../../assets/icons/amenities/local_laundry_service.png" alt="">
              <span></span>Laundry/Valet Service
            </li>
            <li class="list-group-item">
              <img src="../../assets/icons/amenities/wifi.png" alt="">
              <span></span>Wi-fi
              throughout the property
            </li>
            <li class="list-group-item">
              <img src="../../assets/icons/amenities/nest_clock_farsight_analog.png" alt="">
              <span></span>24-hour front desk
            </li>
            <li class="list-group-item p-0"></li>
          </ul>
        </div>
        <!-- <div class="row px-4 ">
                <div class="col border border-black">
                    <div class="row justify-content-center">
                        <div class="col-6 col-lg-6  p-3 rounded text-end d-flex align-items-center">
                            <img src="../../assets/icons/amenities/lightbulb_circle.svg" alt=""> <span class="fw-bolder fs-4">Trip Tip!</span>
                        </div>
                        <div class="col-6 col-lg-6 p-3 rounded d-flex align-items-center">
                            <span class="d-inline-block d-lg-flex">Save this deal now and book dates later. You'll have up to 18 months to travel! </span>
                        </div>
                    </div>
                </div>
            </div> -->
      </div>
      <div class="row p-2 p-lg-0 ">
        <div class="col pb-5 pt-lg-4">
          <div class="row border border-dark rounded d-flex align-items-center justify-content-center p-2 p-lg-3">
            <div class="col-lg-4 d-lg-flex justify-content-end align-items-center pb-2 pb-lg-0">
              <img src="../../assets/icons/amenities/lightbulb_circle.svg" alt="" class="pe-1"> <span
                class="fw-bolder fs-4 newRed" :style="branding .detailsTitleBoxTip">Trip Tip!</span>

            </div>
            <div class="col-lg-8">
              <span class="d-inline-block ">Save this deal now and book dates later.<br class="d-lg-none" />
                You'll have up to <span class="fw-bold">{{ branding.monthsNumber }} months to travel!</span> </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid d-lg-flex align-items-center amenities-bg-03" :style="backgroundStyle">
    <div class="container">
      <div class="row justify-content-around ">
        <div class="col-12 centerTitle mt-lg-0 col-lg-6 lh-base p-0 ">
          <span class="h64min" :class="getClassDestination">{{ getDestination.name }}</span>
          <h3 class="text-grey pb-5 pb-lg-0 fw-bold">Getaway for 5 Days & 4 Nights</h3>
        </div>
        <div class="col-12 pt-5 mt-5 pt-lg-0 mt-lg-0 col-lg-4 position-relative">
          <img class="detail8 position-relative " src="../../assets/images/landing/details-section/detailTag2.png" v-if="branding.logoImgUrl"/>
          <p class="fs-6 text-black m-0 pb-5 pb-lg-0 mb-2  mb-lg-0">
            {{ getDestination.packageDescription.paragraph }}
          </p>
        </div>
      </div>
    </div>
  </div>


  <the-reviews />
</template>

<script>
import TheForm from "@/components/landing-page/TheForm.vue";
import TheDetails from "@/components/landing-page/TheDetails.vue"
import TheAmenities from "@/components/landing-page/TheAmenities.vue"
import TheReviews from "@/components/landing-page/TheReviews.vue"
import { ref } from 'vue'
import { useStore } from '@/store/landing';

export default {
  setup() {
    const getImageUrl = (name) => {
      return new URL(`../../assets/${name}`, import.meta.url).href
    }
    return {
      getImageUrl,
      websiteStore: useStore()
    }
  },
  components:
  {
    TheForm,
    TheDetails,
    TheAmenities,
    TheReviews
  },
  computed: {
    getDestination() {
      return this.websiteStore.destinations.find(destination => destination.slug === this.$route.params.destinationSlug)
    },
    getBackground() {
      return 'backgroundImage' + ':' + `url(${this.getDestination.backgrounds[0]})`
    },
    getClassDestination() {
      return this.getDestination.name == 'Los Cabos' ? 'newRed' : this.getDestination.name == 'Vallarta' ? '' : '';
    },
    isDestinoClass() {
      return this.destination;
    },
    backgroundStyle() {
      const isLarge = window.matchMedia('(min-width: 992px)').matches;
        const name = this.getDestination.name;
        switch (name) {
            case 'Puerto Vallarta':
                return {
                    background: isLarge
                        ? `linear-gradient(180deg, #DCF3FB 0.15%, rgba(220, 243, 251, 0.00) 2.28%),
                            linear-gradient(180deg, rgba(255, 255, 255, 0.00) 14.08%, #FFF 74.65%),
                            url(${this.getDestination.backgrounds[2].url}) lightgray 50% 7% / cover no-repeat`
                        : `
                          linear-gradient(180deg, #DCF3FB 0.15%, rgba(220, 243, 251, 0.00) 2.28%),
                          linear-gradient(180deg, rgba(255, 255, 255, 0.00) 14.08%, #FFF 74.65%),
                          url(${this.getDestination.backgrounds[2].url}) lightgray 70% 60% / cover no-repeat`
                };

            case 'Riviera Cancun':
                return {
                    background: isLarge
                        ? `url(${this.getDestination.backgrounds[2].url}) 20% 0% / cover no-repeat `
                        : `
                          linear-gradient(180deg, #DCF3FB 0.15%, rgba(220, 243, 251, 0.00) 2.28%),
                          linear-gradient(180deg, rgba(255, 255, 255, 0.00) 14.08%, #FFF 62.65%),
                          url(${this.getDestination.backgrounds[2].url}) lightgray 50% 0% / cover no-repeat`
                };
                
            case 'Los Cabos':
                return {
                    background: isLarge
                        ? `url(${this.getDestination.backgrounds[2].url}) 50% 0% / cover no-repeat`
                        : `
                          linear-gradient(180deg, #DCF3FB 0.15%, rgba(220, 243, 251, 0.00) 2.28%),
                          linear-gradient(180deg, rgba(255, 255, 255, 0.00) 14.08%, #FFF 62.65%),
                          url(${this.getDestination.backgrounds[3].url}) lightgray 71% 0% / cover no-repeat`
                };

            default:
                return {
                background: isLarge
                    ? `url(${this.getDestination.backgrounds[2].url}) 50% 50% / cover no-repeat`
                    : `
                      linear-gradient(180deg, #DCF3FB 0.15%, rgba(220, 243, 251, 0.00) 2.28%),
                      linear-gradient(180deg, rgba(255, 255, 255, 0.00) 14.08%, #FFF 62.65%),
                      url(${this.getDestination.backgrounds[3].url}) lightgray 71% 0% / cover no-repeat`
                };
        }
      
    },
    branding() {
      return this.websiteStore.getCampaignBranding(this.$route.query.utm_campaign);
    },
    getCopy() {
      return this.websiteStore.getCampaignCopy(this.$route.query.utm_campaign, this.$route.params.destinationSlug);
    }
  },
  mounted() {
      this.websiteStore.setUtmSource(this.$route.query.utm_source);
  }
}


</script>

<style scoped>
.detail1 {
  max-width: 200px;
  top: -50px;
  left: -130px;

}

.detail2 {
  max-width: 64px;
  top: 3px;
  right: -10px;

}

.detail3 {
  max-width: 64px;
  bottom: 3px;
  transform: rotate(190deg);
  left: -20px;

}

.detail4 {
  max-width: 159px;
  bottom: 0px;
  right: 0px;

}

.detail5 {
  max-width: 179px;
  top: -40px;
  left: -50px;
  z-index: 1;
}

.detail6 {
  max-width: 179px;
  bottom: -40px;
  right: -50px;
  z-index: 1;
  transform: rotate(180deg)
}

.detail7 {
  max-width: 109px;
  top: -90px;
  left: 45%;
  z-index: 1;
  transform: rotate(340deg) translateX(-50%);
}

.detail8 {
  max-width: 139px;
  top: -40px;
  left: 45%;
  z-index: 1;
  transform: rotate(0deg) translateX(-50%);

}

.z2 {
  z-index: 4;
  position: relative;
  font-weight: 600;
}

.tagContainer {
  padding-top: 80px;
  margin-top: 20px;
}

.blackfriday {
  top: -100px;
}

.newRed {
  color: #FF1F1F;
}

.main-container {
  background-image: url(/src/assets/images/landing/bg-01.jpeg);
  background-size: 490%;
  background-repeat: no-repeat;
  background-position: 45% 90%;
  /* height: 100vh !important; */
  /* Fallback for browsers that do not support Custom Properties */
  /* height: calc(var(--vh, 1vh) * 100) !important; */
}

.full {
  height: 100vh !important;
  /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100) !important;
}

.lbl-01__title {
  color: #FFF;
  font-family: "Poppins", sans-serif;
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
  /* 111.111% */
}

.lbl-01__sub {
  font-family: "Poppins", sans-serif;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  background-color: #262626;
  color: #FFF;
  font-size: 24px;
}

.lbl-01__p {
  font-family: "Poppins", sans-serif;
  color: #FFF;
}

.bg {
  background-color: rgba(0, 0, 0, .2) !important;
  /* height: 100vh !important; */
  /* Fallback for browsers that do not support Custom Properties */
  /* height: calc(var(--vh, 1vh) * 100) !important; */
}

.my-element {
  /* height: 100vh; */
  /* Fallback for browsers that do not support Custom Properties */
  height: calc(var(--vh, 1vh) * 100);
}

.margin-15 {
  margin: 0%;
  margin-top: 10rem;
}

.arrow-icon {

  /* margin-left: auto;
margin-right: auto;
left: 0;
right: 0;
text-align: center;
bottom: 0px; */
  background-color: #FFF;
  width: 35px;
  border-top-right-radius: 1rem;
  border-top-left-radius: 1rem;
}

.centerTitle{
    margin-top:160px;
}

/*--------------------Amenitties----------*/
.amenities-bg {
  background-image: url(../../assets/images/landing/backgrounds/bg-amenities.jpeg);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 27% 50%;
}

.bg-shadow {
  background-color: rgba(0, 0, 0, .2) !important;
  padding: 5% !important;
  padding-top: 0 !important;
}

.h64 {
  font-size: 64px;
  color: #ffff;
  font-weight: 900;
  line-height: 74px;
}
.h64min {
  font-size: 61px;
  color: #0C9491;
  font-weight: 700;
  line-height: 74px;
}

.price-txt {
  padding: 8px;
  background-color: #FF1F1F;
  color: #ffff;
  font-weight: 600;
  font-size: 24px;
  display: inline-block;
}

.list-group {
  --bs-list-group-item-padding-y: 1rem;
}

.list-group-item {
  border-style: dashed;
  padding-left: 0px;
}

h3 {
  color: #262626;
}

.green-color-text {
  color: #0c9491;
}

.highlights-list {
  background-color: #dcf3fb;
}

.bg-clouds {
  background-image: url(/src/assets/images/landing/backgrounds/clouds.png) !important;
  background-size: contain;
}

.list-group-item {
  background-color: transparent;
}

@media (min-width: 330px) {
    .amenities-bg-03 {
        padding-top: 20px;
        
    }
  .amenities-bg {
  background-image: url(../../assets/images/landing/backgrounds/bg-amenities.jpeg);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
}
  .main-container {
    background-image: url(/src/assets/images/landing/bg-01.jpeg);
    background-size: 351%;
    background-repeat: no-repeat;
    background-position: 50% 100%;
    /* height: 100vh !important; */
    /* Fallback for browsers that do not support Custom Properties */
    /* height: calc(var(--vh, 1vh) * 100) !important; */
  }
}
@media (min-width: 385px) {
    
  .amenities-bg {
  background-image: url(../../assets/images/landing/backgrounds/bg-amenities.jpeg);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50% 50%;
}
  .main-container {
    background-image: url(/src/assets/images/landing/bg-01.jpeg);
    background-size: 375%;
    background-repeat: no-repeat;
    background-position: 50% 100%;
    /* height: 100vh !important; */
    /* Fallback for browsers that do not support Custom Properties */
    /* height: calc(var(--vh, 1vh) * 100) !important; */
  }
}

@media (min-width: 460px) {

  .main-container {
    background-image: url(/src/assets/images/landing/bg-01.jpeg);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 90%;
    /* height: 100vh !important; */
    /* Fallback for browsers that do not support Custom Properties */
    /* height: calc(var(--vh, 1vh) * 100) !important; */
  }
}

@media (min-width: 768px) {
    .amenities-bg-03 {
        
        padding-top: 160px;
    }
    .centerTitle {
        margin-top: 10px;
    }
  .main-container {
    background-image: url(/src/assets/images/landing/bg-01.jpeg);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 45% 90%;
    /* height: 100vh !important; */
    /* Fallback for browsers that do not support Custom Properties */
    /* height: calc(var(--vh, 1vh) * 100) !important; */
  }
}

@media (min-width: 992px) {
   .amenities-bg-03 {
    min-height:75vh;
    padding-top: 60px;
    
   }
  .lbl-01__title {
    padding-top: 0%;
    margin-top: 0%;
    color: #FFF;
    font-family: "Poppins", sans-serif;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
    /* 111.111% */
  }

  .main-container {
    background-image: url(/src/assets/images/landing/bg-01.jpeg);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    /* height: 100vh !important; */
    /* Fallback for browsers that do not support Custom Properties */
    /* height: calc(var(--vh, 1vh) * 100) !important; */
  }

  .blackfriday {
    top: -25px !important;
    left: 0;
  }

  .detail1 {
    max-width: 450px;
    top: -160px;
    left: -230px;

  }

  .detail2 {
    max-width: 134px;
    top: 3px;
    right: 0px;

  }

  .detail3 {
    max-width: 134px;
    bottom: 3px;
    transform: rotate(190deg);
    left: -20px;

  }

  .detail4 {
    max-width: 338px;
    bottom: 0px;
    right: 0px;

  }

  .detail5 {
    max-width: 256px;
    top: -60px;
    left: -70px;
    z-index: 1;
  }

  .detail6 {
    max-width: 256px;
    bottom: -60px;
    right: -80px;
    z-index: 1;
    transform: rotate(180deg)
  }

  .detail7 {
    position: relative !important;
    max-width: 122px;
    top: -30px;
    left: 45%;
    z-index: 1;
    transform: rotate(340deg) translateX(-50%);
  }

  .detail8 {
    position: absolute !important;
    max-width: 132px;
    top: 50px;
    left: -70px;
    z-index: 1;

  }

  .colSim {
    width: 44%;
  }

  .contBlack {
    padding-left: 9%;
  }

  .p-lg-12 {
    padding: 0rem 9%;
  }

  .margin-15 {
    margin: 11%;
  }
}
</style>